import 'can-construct-super';
import Control from 'can-control';


/**
 * Стандартный контроллер плеера
 **/

const PlayerBase = Control.extend(
    {
        defaults: {

        }
    },
    {
        init() { }
    }
);

export default PlayerBase;